var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticStyle: { height: "100vh" } },
    [
      _c("LayoutBroker", {
        attrs: {
          layouts: _vm.$options.layouts,
          current: _vm.$route.meta.layout,
        },
      }),
      _c("SnackbarsBroker", {
        attrs: {
          "default-x": "right",
          "default-y": "top",
          "default-color": "success darken-2",
          "default-timeout": 5000,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }